function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M394.05,350l.07-8.2L292.07,317l-177.7,59.46V385a1.74,1.74,0,0,0,.39,1.13,2.64,2.64,0,0,0,1.17.79l99.9,41.23a10.84,10.84,0,0,0,2.54.65,17.54,17.54,0,0,0,5.84-.15,11.64,11.64,0,0,0,2.56-.79L392.86,352a1.66,1.66,0,0,0,.84-.66A2,2,0,0,0,394.05,350Z",
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-64.6 237.38) rotate(-45)",
  cx: 254.25,
  cy: 196.67,
  r: 108.67,
  fill: "#fff",
  stroke: "#263238",
  strokeMiterlimit: 10
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M250.34,146.36,260.66,151l2.83,4.64,4.65,1.81.51,4.9-1.8,2.84-3.61.77-7.74-3.1v-1l4.38-1.8-1.55-5.42-7-2.58-3.09-4.12Zm65,119.15-8.25-3.35L297,258.55h-8L281.55,257l-8.26,1.81-4.64.25h-2.84l-5.41,3.1-5.16,2.06-7-4.38,1.8-7.22-4.38-1.81h-5.16l-.77-2.32.51-4.64-1.8-2.58-3.61.51-1,2.58-4.38.26L225.58,240,224,233.79l3.87-7.22,7.48.51,2.06,1.81h3.1l3.87-2.32,3.35,1,4.64,8,1.81-.25-.52-5.94-1.54-3.09.51-4.9,9.54-4.13,1.29-9.54,4.13-3.35,3.35-5.93,2.58-.52,5.93-3.87.26-2.06-4.13.26-.77-2.07H272l-4.38,1,2.06-3.35,9-2.58,2.06-2.32,3.61,5.67,2.33,2.33,3.61-1-1.55-3.35-5.42-3.87-6.19-7-6.45-4.39-6.19-1-3.09-3.09-4.13-1-.51,1-.52,7.48,1,2.58L255,185.56l-5.16-4.13.78-3.61-5.42-2.58-2.32-2.83,1.29-6.45,7.48-5.42.52-6.19-2.84.26-1.81-2.32-.77-3.87-1.81-.26-1,4.13-2.83.52-1.29-9-2.07-1.29-3.61-1.55L230,143l5.15,4.91,1,4.38-9.28-7-6.45-7-.51-7-6.71-2.06L208,132.69a38.83,38.83,0,0,1-3.87,2.06,42.49,42.49,0,0,1-6.19,1l-1,4.39-5.93.26.52,2.83,9.54,1.55,4.9,5.42v9l-2.84,8,.52,8.51-7.22,12.64-1.55,18.82,2.32,10.84,3.35,8.25,3.87.52-1.29-4.13-2.06-3.1-1.29-5.67,2.32-.52,3.61,9.29L208.3,231v6.71l4.9,5.93L222,250l13.41,3.61,4.13,3.87,3.09,4.12,4.64,2.84,5.68,1.55,5.67-.26s-.26,2.58-.26,3.87-3.61,5.67-3.61,5.67l-2.83,5.16,2.06,5.67,5.67,2.33,8,8.25,3.61,1.55v3.86l.45,1.81a108.27,108.27,0,0,0,54.09-25.47l.14-1.87,7-12.64-3.35-2.32Zm26.83-101.87-2.84-4.9-3.61-5.68-1-7.73,4.64.77.26-2.58-3.36-.26,2.84-1.29,3.1-1.8v-2.58l-3.1-4.13-.66-5.55A108.77,108.77,0,0,0,210.86,97l5.95,4.21-3.61,4.65-4.9,1-.52,7-2.06.77-2.58,2.84.26,4.64,4.38.52L206,127h4.38l7.48-9.54.78-4.12,7.22-.52,1.8-3.1,7.48-.77.78-4.38,5.41-.26s3.87-2.06,4.65-2.06a31.7,31.7,0,0,1,4.38,1.28l3.87,3.1h5.41l4.65-2.84,5.93.52a6.39,6.39,0,0,0,2.84,1c1.29,0,5.15-1.81,5.15-1.81l7.48,4.65,3.1,2.32v3.87l3.87.51,1.29-2.32,3.35,1.55-.26,2.06-7.74,2.07,4.39,5.67,9.28,5.16,3.87,5.16,5.68.51,1.29-2.58,2.06-.51-6.71-5.16L305,126l3.35-1-3.1-4.38,4.39-.26,5.67,3.09,1.29,6.19,2.84,3.36,2.32,7.48,5.67,4.12v8.51l5.94,3.87-.26,2.84-.78,3.35,1.55,4.64.52,2.33,4.38.77,2.07-4.39Zm3.35-26v1.48l-1.29,4.12.77,3.61,2.84,1v4.9l-3.1-1.29L344,165.44l-3.09,5.68,2.06,7.22,3.35,3.09v13.93l3.35,10.83,3.62,8.26,5.93,1.54,2.06-5.16.84-.65a109.63,109.63,0,0,0,.84-13.51A108.14,108.14,0,0,0,345.51,137.66ZM285.93,136l-17-7.48-7.48.26-1.81,4.9-3.09-3.35-5.67,1.29-.52,8.51,4.64,3.35,3.35-4.9,3.87,3.87,8,7,1.55,7.48,6.7,8.51,10.83-1.8-.25-3.87-2.32-4.39-.52-10.31,2.58-4.39Zm13.93,5.68-3.87-1-3.35,2.84,1.8,7.48h3.36Zm24,4.9L315.08,142l-1.81-3.09-2.06.77,1.8,5.16,1.55,6.71,3.87,1.54.77-1-2.32-3.87,6.71,2.58Zm-75.31,93.1-1,1,7.74,2.32,3.09,3.61,4.91.52,1.8-2.84-5.93-1Zm23,4.9-5.42,1.55.78,2.06h6.7l1.29-2.06-2.32.26Z",
  fill: "#91C788",
  stroke: "#263238",
  strokeMiterlimit: 10
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m431.8 261.49c4.11-27 1.17-54.8-6-81-6.44-23.51-14.56-47.65-33.46-64.16-22.9-20-51.49-22.61-80.51-19.22-57.43 6.69-73.83-17.91-116.32-16.42s-79.76 19.38-91.69 55.91 6.71 74.55-2.24 96.16-34.29 43.24-19.38 74.55 47.71 55.91 123.8 61.87 142.38 8.95 185.62-30.56c23.38-21.41 35.8-48.39 40.18-77.13z",
  fill: "#91C788"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m431.8 261.49c4.11-27 1.17-54.8-6-81-6.44-23.51-14.56-47.65-33.46-64.16-22.9-20-51.49-22.61-80.51-19.22-57.43 6.69-73.83-17.91-116.32-16.42s-79.76 19.38-91.69 55.91 6.71 74.55-2.24 96.16-34.29 43.24-19.38 74.55 47.71 55.91 123.8 61.87 142.38 8.95 185.62-30.56c23.38-21.41 35.8-48.39 40.18-77.13z",
  fill: "#fff",
  opacity: 0.7
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M394.05,350l.07-8.2L292.07,317l-177.7,59.46V385a1.74,1.74,0,0,0,.39,1.13,2.64,2.64,0,0,0,1.17.79l99.9,41.23a10.84,10.84,0,0,0,2.54.65,17.54,17.54,0,0,0,5.84-.15,11.64,11.64,0,0,0,2.56-.79L392.86,352a1.66,1.66,0,0,0,.84-.66A2,2,0,0,0,394.05,350Z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M393.7,351.36a2,2,0,0,0,.35-1.33l.07-8.2L292.07,317l-68.76,23v88.76c.3,0,.61-.08.9-.14a11.64,11.64,0,0,0,2.56-.79L392.86,352A1.66,1.66,0,0,0,393.7,351.36Z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "m220.56 429.13v-13.77h-3.48v13.34a11 11 0 0 0 3.48 0.43z",
  opacity: 0.2
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M394.05,350l.07-8.2L292.07,317l-177.7,59.46V385a1.74,1.74,0,0,0,.39,1.13,2.64,2.64,0,0,0,1.17.79l99.9,41.23a10.84,10.84,0,0,0,2.54.65,17.54,17.54,0,0,0,5.84-.15,11.64,11.64,0,0,0,2.56-.79L392.86,352a1.66,1.66,0,0,0,.84-.66A2,2,0,0,0,394.05,350Z",
  fill: "none",
  stroke: "#263238",
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M341.84,331.61l-13.07-3.31a3.45,3.45,0,0,0-.59-.1c-.21,0-.43,0-.64,0a5.6,5.6,0,0,0-.6.05,2.93,2.93,0,0,0-.49.12.66.66,0,0,0-.29.18.2.2,0,0,0,0,.19.44.44,0,0,0,.21.19,1.57,1.57,0,0,0,.44.16l13.07,3.34a5.55,5.55,0,0,0,.61.1l.65,0a5.73,5.73,0,0,0,.61-.06,2.51,2.51,0,0,0,.49-.12.75.75,0,0,0,.28-.18.19.19,0,0,0,0-.2.54.54,0,0,0-.22-.2,2.3,2.3,0,0,0-.45-.16",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M380.13,342.9l-22.05-5.62h-3.61c-.4,0-.79,0-1.18,0s-.78-.05-1.15-.1-.75-.1-1.11-.16-.69-.14-1-.22l-38.45-9.87-.78-.24c-.24-.09-.45-.18-.64-.27a3.6,3.6,0,0,1-.48-.3,1.44,1.44,0,0,1-.3-.31l-.77-1.12-19.74-5L138.54,371.5l94.88,36.33L380.13,342.9",
  fill: "#91C788",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: "3px"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M394.41,341.13a2.47,2.47,0,0,0-.92-.7,7.82,7.82,0,0,0-1.71-.6l-96.29-24a13.55,13.55,0,0,0-1.84-.31,19.1,19.1,0,0,0-2-.07,15,15,0,0,0-1.94.15,9.5,9.5,0,0,0-1.64.37l-171.4,58.14a7.31,7.31,0,0,0-1.79.85,2.12,2.12,0,0,0-.86.94.91.91,0,0,0,.12.92,2.59,2.59,0,0,0,1.16.8l100.54,40.71a10.83,10.83,0,0,0,2.54.66,17.54,17.54,0,0,0,5.84-.15,11.64,11.64,0,0,0,2.56-.79l166.87-75.56a1.75,1.75,0,0,0,.85-.67A.68.68,0,0,0,394.41,341.13Zm-161,66.7L138.54,371.5l150.32-51.89,19.74,5,.77,1.12a1.44,1.44,0,0,0,.3.31,3.6,3.6,0,0,0,.48.3c.19.09.4.18.64.27l.78.24L350,336.76c.32.08.66.16,1,.22s.73.12,1.11.16.76.08,1.15.1.78,0,1.18,0h3.61l22.05,5.62Zm92.74-79.31a.66.66,0,0,1,.29-.18,2.93,2.93,0,0,1,.49-.12,5.6,5.6,0,0,1,.6-.05c.21,0,.43,0,.64,0a3.45,3.45,0,0,1,.59.1l13.07,3.31a2.3,2.3,0,0,1,.45.16.54.54,0,0,1,.22.2.19.19,0,0,1,0,.2.75.75,0,0,1-.28.18,2.51,2.51,0,0,1-.49.12,5.73,5.73,0,0,1-.61.06l-.65,0a5.55,5.55,0,0,1-.61-.1l-13.07-3.34a1.57,1.57,0,0,1-.44-.16.44.44,0,0,1-.21-.19A.2.2,0,0,1,326.16,328.52ZM180.67,391.66a2.77,2.77,0,0,1-.78.44,6,6,0,0,1-1.13.3,7.46,7.46,0,0,1-1.25.13,8,8,0,0,1-1.22-.06,4.79,4.79,0,0,1-1-.26,1.78,1.78,0,0,1-.65-.41.59.59,0,0,1-.16-.47.84.84,0,0,1,.33-.48,2.54,2.54,0,0,1,.78-.44,6,6,0,0,1,1.13-.3,8.4,8.4,0,0,1,1.24-.12,8,8,0,0,1,1.21.06,4.86,4.86,0,0,1,1,.25,1.69,1.69,0,0,1,.65.4.54.54,0,0,1,.17.47A.82.82,0,0,1,180.67,391.66Z",
  fill: "#263238"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M180.16,390.3a4.86,4.86,0,0,0-1-.25,8,8,0,0,0-1.21-.06,8.4,8.4,0,0,0-1.24.12,6,6,0,0,0-1.13.3,2.54,2.54,0,0,0-.78.44.84.84,0,0,0-.33.48.59.59,0,0,0,.16.47,1.78,1.78,0,0,0,.65.41,4.79,4.79,0,0,0,1,.26,8,8,0,0,0,1.22.06,7.46,7.46,0,0,0,1.25-.13,6,6,0,0,0,1.13-.3,2.77,2.77,0,0,0,.78-.44.82.82,0,0,0,.31-.49.54.54,0,0,0-.17-.47,1.69,1.69,0,0,0-.65-.4",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#263238",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("line", {
  x1: 146.79,
  x2: 149.65,
  y1: 346.94,
  y2: 351.78
}), /*#__PURE__*/React.createElement("line", {
  x1: 104.77,
  x2: 143.56,
  y1: 275.87,
  y2: 341.47
}), /*#__PURE__*/React.createElement("line", {
  x1: 179.6,
  x2: 181.23,
  y1: 332.92,
  y2: 336.82
}), /*#__PURE__*/React.createElement("line", {
  x1: 168.49,
  x2: 177.78,
  y1: 306.34,
  y2: 328.56
}), /*#__PURE__*/React.createElement("line", {
  x1: 362.12,
  x2: 341.68,
  y1: 272.19,
  y2: 322.41
}), /*#__PURE__*/React.createElement("line", {
  x1: 367.17,
  x2: 364.64,
  y1: 259.8,
  y2: 265.99
}), /*#__PURE__*/React.createElement("line", {
  x1: 378.51,
  x2: 374.05,
  y1: 321.38,
  y2: 326.29
}), /*#__PURE__*/React.createElement("line", {
  x1: 407.29,
  x2: 382.97,
  y1: 289.72,
  y2: 316.47
}), /*#__PURE__*/React.createElement("line", {
  x1: 161.84,
  x2: 178.46,
  y1: 339.59,
  y2: 371.72
}), /*#__PURE__*/React.createElement("line", {
  x1: 365.74,
  x2: 347.45,
  y1: 319.64,
  y2: 344.57
}), /*#__PURE__*/React.createElement("line", {
  x1: 248.83,
  x2: 253.26,
  y1: 319.64,
  y2: 341.8
}));

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 168.48,
  cy: 108.87,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m172.09 108.13h-7.09a2.51 2.51 0 0 0-2.51 2.51v6a9.76 9.76 0 0 0 12.11-0.09v-5.86a2.51 2.51 0 0 0-2.51-2.56z",
  fill: "#91C788"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 168.42,
  cy: 103.43,
  r: 3.61,
  fill: "#91C788"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-162.08 368.83) rotate(-68.66)",
  cx: 189,
  cy: 303.08,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m192.61 302.35h-7.1a2.5 2.5 0 0 0-2.5 2.5v5.95a9.75 9.75 0 0 0 12.1-0.09v-5.86a2.5 2.5 0 0 0-2.5-2.5z",
  fill: "#91C788"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m188.94 301.25a3.61 3.61 0 1 0-3.61-3.61 3.61 3.61 0 0 0 3.61 3.61z",
  fill: "#91C788"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-64.6 237.38) rotate(-45)",
  cx: 254.25,
  cy: 196.67,
  r: 108.67,
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-64.6 237.38) rotate(-45)",
  cx: 254.25,
  cy: 196.67,
  r: 108.67,
  opacity: 0.18
}), /*#__PURE__*/React.createElement("path", {
  d: "m254.25 243.09a108.71 108.71 0 0 1-104.14-77.55 108.67 108.67 0 1 0 208.28 0 108.72 108.72 0 0 1-104.14 77.55z",
  fill: "#fff",
  opacity: 0.86
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.34,146.36,260.66,151l2.83,4.64,4.65,1.81.51,4.9-1.8,2.84-3.61.77-7.74-3.1v-1l4.38-1.8-1.55-5.42-7-2.58-3.09-4.12Zm65,119.15-8.25-3.35L297,258.55h-8L281.55,257l-8.26,1.81-4.64.25h-2.84l-5.41,3.1-5.16,2.06-7-4.38,1.8-7.22-4.38-1.81h-5.16l-.77-2.32.51-4.64-1.8-2.58-3.61.51-1,2.58-4.38.26L225.58,240,224,233.79l3.87-7.22,7.48.51,2.06,1.81h3.1l3.87-2.32,3.35,1,4.64,8,1.81-.25-.52-5.94-1.54-3.09.51-4.9,9.54-4.13,1.29-9.54,4.13-3.35,3.35-5.93,2.58-.52,5.93-3.87.26-2.06-4.13.26-.77-2.07H272l-4.38,1,2.06-3.35,9-2.58,2.06-2.32,3.61,5.67,2.33,2.33,3.61-1-1.55-3.35-5.42-3.87-6.19-7-6.45-4.39-6.19-1-3.09-3.09-4.13-1-.51,1-.52,7.48,1,2.58L255,185.56l-5.16-4.13.78-3.61-5.42-2.58-2.32-2.83,1.29-6.45,7.48-5.42.52-6.19-2.84.26-1.81-2.32-.77-3.87-1.81-.26-1,4.13-2.83.52-1.29-9-2.07-1.29-3.61-1.55L230,143l5.15,4.91,1,4.38-9.28-7-6.45-7-.51-7-6.71-2.06L208,132.69a38.83,38.83,0,0,1-3.87,2.06,42.49,42.49,0,0,1-6.19,1l-1,4.39-5.93.26.52,2.83,9.54,1.55,4.9,5.42v9l-2.84,8,.52,8.51-7.22,12.64-1.55,18.82,2.32,10.84,3.35,8.25,3.87.52-1.29-4.13-2.06-3.1-1.29-5.67,2.32-.52,3.61,9.29L208.3,231v6.71l4.9,5.93L222,250l13.41,3.61,4.13,3.87,3.09,4.12,4.64,2.84,5.68,1.55,5.67-.26s-.26,2.58-.26,3.87-3.61,5.67-3.61,5.67l-2.83,5.16,2.06,5.67,5.67,2.33,8,8.25,3.61,1.55v3.86l.45,1.81a108.27,108.27,0,0,0,54.09-25.47l.14-1.87,7-12.64-3.35-2.32Zm26.83-101.87-2.84-4.9-3.61-5.68-1-7.73,4.64.77.26-2.58-3.36-.26,2.84-1.29,3.1-1.8v-2.58l-3.1-4.13-.66-5.55A108.77,108.77,0,0,0,210.86,97l5.95,4.21-3.61,4.65-4.9,1-.52,7-2.06.77-2.58,2.84.26,4.64,4.38.52L206,127h4.38l7.48-9.54.78-4.12,7.22-.52,1.8-3.1,7.48-.77.78-4.38,5.41-.26s3.87-2.06,4.65-2.06a31.7,31.7,0,0,1,4.38,1.28l3.87,3.1h5.41l4.65-2.84,5.93.52a6.39,6.39,0,0,0,2.84,1c1.29,0,5.15-1.81,5.15-1.81l7.48,4.65,3.1,2.32v3.87l3.87.51,1.29-2.32,3.35,1.55-.26,2.06-7.74,2.07,4.39,5.67,9.28,5.16,3.87,5.16,5.68.51,1.29-2.58,2.06-.51-6.71-5.16L305,126l3.35-1-3.1-4.38,4.39-.26,5.67,3.09,1.29,6.19,2.84,3.36,2.32,7.48,5.67,4.12v8.51l5.94,3.87-.26,2.84-.78,3.35,1.55,4.64.52,2.33,4.38.77,2.07-4.39Zm3.35-26v1.48l-1.29,4.12.77,3.61,2.84,1v4.9l-3.1-1.29L344,165.44l-3.09,5.68,2.06,7.22,3.35,3.09v13.93l3.35,10.83,3.62,8.26,5.93,1.54,2.06-5.16.84-.65a109.63,109.63,0,0,0,.84-13.51A108.14,108.14,0,0,0,345.51,137.66ZM285.93,136l-17-7.48-7.48.26-1.81,4.9-3.09-3.35-5.67,1.29-.52,8.51,4.64,3.35,3.35-4.9,3.87,3.87,8,7,1.55,7.48,6.7,8.51,10.83-1.8-.25-3.87-2.32-4.39-.52-10.31,2.58-4.39Zm13.93,5.68-3.87-1-3.35,2.84,1.8,7.48h3.36Zm24,4.9L315.08,142l-1.81-3.09-2.06.77,1.8,5.16,1.55,6.71,3.87,1.54.77-1-2.32-3.87,6.71,2.58Zm-75.31,93.1-1,1,7.74,2.32,3.09,3.61,4.91.52,1.8-2.84-5.93-1Zm23,4.9-5.42,1.55.78,2.06h6.7l1.29-2.06-2.32.26Z",
  fill: "#91C788"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m254.25 243.09a108.71 108.71 0 0 1-104.14-77.55 108.67 108.67 0 1 0 208.28 0 108.72 108.72 0 0 1-104.14 77.55z",
  fill: "#fff",
  opacity: 0.65
})), /*#__PURE__*/React.createElement("path", {
  d: "M250.34,146.36,260.66,151l2.83,4.64,4.65,1.81.51,4.9-1.8,2.84-3.61.77-7.74-3.1v-1l4.38-1.8-1.55-5.42-7-2.58-3.09-4.12Zm65,119.15-8.25-3.35L297,258.55h-8L281.55,257l-8.26,1.81-4.64.25h-2.84l-5.41,3.1-5.16,2.06-7-4.38,1.8-7.22-4.38-1.81h-5.16l-.77-2.32.51-4.64-1.8-2.58-3.61.51-1,2.58-4.38.26L225.58,240,224,233.79l3.87-7.22,7.48.51,2.06,1.81h3.1l3.87-2.32,3.35,1,4.64,8,1.81-.25-.52-5.94-1.54-3.09.51-4.9,9.54-4.13,1.29-9.54,4.13-3.35,3.35-5.93,2.58-.52,5.93-3.87.26-2.06-4.13.26-.77-2.07H272l-4.38,1,2.06-3.35,9-2.58,2.06-2.32,3.61,5.67,2.33,2.33,3.61-1-1.55-3.35-5.42-3.87-6.19-7-6.45-4.39-6.19-1-3.09-3.09-4.13-1-.51,1-.52,7.48,1,2.58L255,185.56l-5.16-4.13.78-3.61-5.42-2.58-2.32-2.83,1.29-6.45,7.48-5.42.52-6.19-2.84.26-1.81-2.32-.77-3.87-1.81-.26-1,4.13-2.83.52-1.29-9-2.07-1.29-3.61-1.55L230,143l5.15,4.91,1,4.38-9.28-7-6.45-7-.51-7-6.71-2.06L208,132.69a38.83,38.83,0,0,1-3.87,2.06,42.49,42.49,0,0,1-6.19,1l-1,4.39-5.93.26.52,2.83,9.54,1.55,4.9,5.42v9l-2.84,8,.52,8.51-7.22,12.64-1.55,18.82,2.32,10.84,3.35,8.25,3.87.52-1.29-4.13-2.06-3.1-1.29-5.67,2.32-.52,3.61,9.29L208.3,231v6.71l4.9,5.93L222,250l13.41,3.61,4.13,3.87,3.09,4.12,4.64,2.84,5.68,1.55,5.67-.26s-.26,2.58-.26,3.87-3.61,5.67-3.61,5.67l-2.83,5.16,2.06,5.67,5.67,2.33,8,8.25,3.61,1.55v3.86l.45,1.81a108.27,108.27,0,0,0,54.09-25.47l.14-1.87,7-12.64-3.35-2.32Zm26.83-101.87-2.84-4.9-3.61-5.68-1-7.73,4.64.77.26-2.58-3.36-.26,2.84-1.29,3.1-1.8v-2.58l-3.1-4.13-.66-5.55A108.77,108.77,0,0,0,210.86,97l5.95,4.21-3.61,4.65-4.9,1-.52,7-2.06.77-2.58,2.84.26,4.64,4.38.52L206,127h4.38l7.48-9.54.78-4.12,7.22-.52,1.8-3.1,7.48-.77.78-4.38,5.41-.26s3.87-2.06,4.65-2.06a31.7,31.7,0,0,1,4.38,1.28l3.87,3.1h5.41l4.65-2.84,5.93.52a6.39,6.39,0,0,0,2.84,1c1.29,0,5.15-1.81,5.15-1.81l7.48,4.65,3.1,2.32v3.87l3.87.51,1.29-2.32,3.35,1.55-.26,2.06-7.74,2.07,4.39,5.67,9.28,5.16,3.87,5.16,5.68.51,1.29-2.58,2.06-.51-6.71-5.16L305,126l3.35-1-3.1-4.38,4.39-.26,5.67,3.09,1.29,6.19,2.84,3.36,2.32,7.48,5.67,4.12v8.51l5.94,3.87-.26,2.84-.78,3.35,1.55,4.64.52,2.33,4.38.77,2.07-4.39Zm3.35-26v1.48l-1.29,4.12.77,3.61,2.84,1v4.9l-3.1-1.29L344,165.44l-3.09,5.68,2.06,7.22,3.35,3.09v13.93l3.35,10.83,3.62,8.26,5.93,1.54,2.06-5.16.84-.65a109.63,109.63,0,0,0,.84-13.51A108.14,108.14,0,0,0,345.51,137.66ZM285.93,136l-17-7.48-7.48.26-1.81,4.9-3.09-3.35-5.67,1.29-.52,8.51,4.64,3.35,3.35-4.9,3.87,3.87,8,7,1.55,7.48,6.7,8.51,10.83-1.8-.25-3.87-2.32-4.39-.52-10.31,2.58-4.39Zm13.93,5.68-3.87-1-3.35,2.84,1.8,7.48h3.36Zm24,4.9L315.08,142l-1.81-3.09-2.06.77,1.8,5.16,1.55,6.71,3.87,1.54.77-1-2.32-3.87,6.71,2.58Zm-75.31,93.1-1,1,7.74,2.32,3.09,3.61,4.91.52,1.8-2.84-5.93-1Zm23,4.9-5.42,1.55.78,2.06h6.7l1.29-2.06-2.32.26Z",
  fill: "none",
  stroke: "#263238",
  strokeMiterlimit: 10
}));

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-64.6 237.38) rotate(-45)",
  cx: 254.25,
  cy: 196.67,
  r: 108.67,
  fill: "none",
  stroke: "#263238",
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-17.7 64.3) rotate(-9.25)",
  cx: 388.63,
  cy: 141.59,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "m392.24 140.85h-7.1a2.5 2.5 0 0 0-2.5 2.51v5.95a9.75 9.75 0 0 0 12.1-0.09v-5.86a2.5 2.5 0 0 0-2.5-2.51z",
  fill: "#91C788"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "m388.57 139.75a3.61 3.61 0 1 0-3.61-3.61 3.61 3.61 0 0 0 3.61 3.61z",
  fill: "#91C788"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 311.96,
  cy: 97.92,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "m315.56 97.18h-7.09a2.51 2.51 0 0 0-2.47 2.51v6a9.76 9.76 0 0 0 12.11-0.09v-5.91a2.51 2.51 0 0 0-2.55-2.51z",
  fill: "#91C788"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 311.89,
  cy: 92.47,
  r: 3.61,
  fill: "#91C788"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-24.88 20.64) rotate(-9.25)",
  cx: 115.13,
  cy: 164.09,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m118.74 163.35h-7.1a2.5 2.5 0 0 0-2.5 2.51v5.95a9.75 9.75 0 0 0 12.1-0.09v-5.86a2.5 2.5 0 0 0-2.5-2.51z",
  fill: "#91C788"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "m115.07 162.25a3.61 3.61 0 1 0-3.61-3.61 3.61 3.61 0 0 0 3.61 3.61z",
  fill: "#91C788"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-35.79 22.65) rotate(-9.25)",
  cx: 122.13,
  cy: 232.59,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m125.74 231.85h-7.1a2.5 2.5 0 0 0-2.5 2.51v5.95a9.75 9.75 0 0 0 12.1-0.09v-5.86a2.5 2.5 0 0 0-2.5-2.51z",
  fill: "#91C788"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "m122.07 230.75a3.61 3.61 0 1 0-3.61-3.61 3.61 3.61 0 0 0 3.61 3.61z",
  fill: "#91C788"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-59.73 267.45) rotate(-68.51)",
  cx: 166.5,
  cy: 177.58,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "m170.11 176.85h-7.11a2.5 2.5 0 0 0-2.5 2.5v6a9.75 9.75 0 0 0 12.1-0.09v-5.86a2.5 2.5 0 0 0-2.49-2.55z",
  fill: "#91C788"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "m166.44 175.75a3.61 3.61 0 1 0-3.61-3.61 3.61 3.61 0 0 0 3.61 3.61z",
  fill: "#91C788"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 238.27,
  cy: 284.33,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "m241.88 283.6h-7.09a2.51 2.51 0 0 0-2.51 2.51v5.95a9.76 9.76 0 0 0 12.11-0.09v-5.86a2.51 2.51 0 0 0-2.51-2.51z",
  fill: "#91C788"
});

var _ref39 = /*#__PURE__*/React.createElement("circle", {
  cx: 238.21,
  cy: 278.89,
  r: 3.61,
  fill: "#91C788"
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  cx: 316.5,
  cy: 305.25,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "m320.1 304.52h-7.1a2.51 2.51 0 0 0-2.51 2.5v6a9.76 9.76 0 0 0 12.11-0.09v-5.93a2.5 2.5 0 0 0-2.5-2.48z",
  fill: "#91C788"
});

var _ref42 = /*#__PURE__*/React.createElement("circle", {
  cx: 316.43,
  cy: 299.81,
  r: 3.61,
  fill: "#91C788"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(15.66 507.59) rotate(-69.82)",
  cx: 371.5,
  cy: 242.58,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "m375.11 241.85h-7.11a2.5 2.5 0 0 0-2.5 2.5v6a9.75 9.75 0 0 0 12.1-0.09v-5.86a2.5 2.5 0 0 0-2.49-2.55z",
  fill: "#91C788"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "m371.44 240.75a3.61 3.61 0 1 0-3.61-3.61 3.61 3.61 0 0 0 3.61 3.61z",
  fill: "#91C788"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "m349.86 144.64c15.36 12.45 24.47 28 24.47 44.78 0 41-54.17 74.26-121 74.26s-121-33.25-121-74.26c0-17.94 10.37-34.39 27.63-47.23",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "m184 113.75c10.89-17.85 26.2-29.75 44.34-32.4 42.62-6.14 84.73 41.47 94.07 106.34s-17.63 122.43-60.24 128.57c-19.4 2.79-38.7-5.55-54.85-21.59",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref48 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "translate(-60.53 307.49) rotate(-58.58)",
  cx: 243.81,
  cy: 207.7,
  rx: 49.19,
  ry: 121.67,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref49 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "translate(-68.38 161.4) rotate(-31.42)",
  cx: 252.72,
  cy: 202.26,
  rx: 124.86,
  ry: 49.19,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "m304.07 128a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "m326.07 209.87a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "m321.67 251.46a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "m308.91 283.14a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "m347 238a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "m244.22 263.12a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "m153.13 229.9a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "m168.53 209.21a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "m244.44 151.35a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "m363.25 156.41a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "m140.59 166.09a2 2 0 1 0-2 2 2 2 0 0 0 2-2z",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref61 = /*#__PURE__*/React.createElement("line", {
  x1: 363.23,
  x2: 378.95,
  y1: 155.62,
  y2: 147.16,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref62 = /*#__PURE__*/React.createElement("line", {
  x1: 136.63,
  x2: 126.01,
  y1: 166.09,
  y2: 164.09,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref63 = /*#__PURE__*/React.createElement("line", {
  x1: 166.55,
  x2: 166.55,
  y1: 207.23,
  y2: 188.46,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref64 = /*#__PURE__*/React.createElement("line", {
  x1: 149.17,
  x2: 133.01,
  y1: 229.9,
  y2: 232.59,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref65 = /*#__PURE__*/React.createElement("line", {
  x1: 241.79,
  x2: 240.31,
  y1: 265.07,
  y2: 273.77,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref66 = /*#__PURE__*/React.createElement("line", {
  x1: 307.68,
  x2: 312.31,
  y1: 285.05,
  y2: 295.13,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref67 = /*#__PURE__*/React.createElement("line", {
  x1: 346.97,
  x2: 360.41,
  y1: 238.04,
  y2: 240.92,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref68 = /*#__PURE__*/React.createElement("line", {
  x1: 318.09,
  x2: 305.04,
  y1: 250.01,
  y2: 237.45,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref69 = /*#__PURE__*/React.createElement("line", {
  x1: 302.89,
  x2: 308.84,
  y1: 126.22,
  y2: 108.53,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref70 = /*#__PURE__*/React.createElement("line", {
  x1: 176.38,
  x2: 178.9,
  y1: 116.95,
  y2: 118.84,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref71 = /*#__PURE__*/React.createElement("line", {
  x1: 195.6,
  x2: 198.43,
  y1: 294.31,
  y2: 290.53,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref72 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(-23 426.91) rotate(-69.36)",
  cx: 297,
  cy: 230.08,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "m300.61 229.35h-7.1a2.5 2.5 0 0 0-2.5 2.5v6a9.75 9.75 0 0 0 12.1-0.09v-5.86a2.5 2.5 0 0 0-2.5-2.55z",
  fill: "#91C788"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "m296.94 228.25a3.61 3.61 0 1 0-3.61-3.61 3.61 3.61 0 0 0 3.61 3.61z",
  fill: "#91C788"
});

var _ref75 = /*#__PURE__*/React.createElement("circle", {
  transform: "translate(41.69 417.24) rotate(-69.51)",
  cx: 321.5,
  cy: 178.58,
  r: 10.88,
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: ".5px"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "m325.11 177.85h-7.11a2.5 2.5 0 0 0-2.5 2.5v6a9.75 9.75 0 0 0 12.1-0.09v-5.86a2.5 2.5 0 0 0-2.49-2.55z",
  fill: "#91C788"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "m321.44 176.75a3.61 3.61 0 1 0-3.61-3.61 3.61 3.61 0 0 0 3.61 3.61z",
  fill: "#91C788"
});

function SvgTopPanl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPanl);
export default __webpack_public_path__ + "static/media/topPanl.955f6186.svg";
export { ForwardRef as ReactComponent };